var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M16,3.2L16,3.2c0.619,0,1.12,0.716,1.12,1.6V8c0,0.884-0.501,1.6-1.12,1.6l0,0c-0.619,0-1.12-0.716-1.12-1.6 V4.8C14.88,3.917,15.381,3.2,16,3.2z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M22.4,4.915L22.4,4.915c0.535,0.309,0.611,1.18,0.17,1.945L20.97,9.632c-0.441,0.765-1.233,1.135-1.77,0.826 l0,0c-0.536-0.309-0.612-1.18-0.17-1.946l1.6-2.771C21.072,4.975,21.864,4.605,22.4,4.915z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.08333333333333333s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M27.085,9.6L27.085,9.6c0.31,0.536-0.06,1.328-0.825,1.77l-2.771,1.6c-0.766,0.442-1.637,0.366-1.945-0.17 l0,0c-0.31-0.536,0.061-1.328,0.825-1.77l2.771-1.6C25.904,8.988,26.775,9.064,27.085,9.6z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.16666666666666666s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M28.8,16L28.8,16c0,0.619-0.716,1.12-1.6,1.12H24c-0.884,0-1.6-0.501-1.6-1.12l0,0 c0-0.619,0.716-1.12,1.6-1.12h3.2C28.084,14.88,28.8,15.381,28.8,16z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.25s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M27.085,22.4L27.085,22.4c-0.31,0.535-1.181,0.611-1.945,0.17l-2.771-1.601 c-0.765-0.441-1.135-1.233-0.825-1.77l0,0c0.309-0.536,1.18-0.612,1.945-0.17l2.771,1.6C27.025,21.072,27.395,21.864,27.085,22.4z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.3333333333333333s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M22.4,27.085L22.4,27.085c-0.536,0.31-1.328-0.06-1.771-0.825l-1.6-2.771 c-0.442-0.766-0.366-1.637,0.17-1.945l0,0c0.536-0.31,1.328,0.061,1.77,0.825l1.601,2.771C23.012,25.904,22.936,26.775,22.4,27.085z "
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.4166666666666667s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M16,28.8L16,28.8c-0.619,0-1.12-0.716-1.12-1.6V24c0-0.884,0.501-1.6,1.12-1.6l0,0 c0.619,0,1.12,0.716,1.12,1.6v3.2C17.12,28.084,16.619,28.8,16,28.8z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.5s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M9.6,27.085L9.6,27.085c-0.536-0.31-0.612-1.181-0.17-1.945l1.6-2.771c0.441-0.765,1.234-1.135,1.77-0.825 l0,0c0.536,0.309,0.612,1.18,0.17,1.945l-1.6,2.771C10.928,27.025,10.136,27.395,9.6,27.085z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.5833333333333334s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M4.915,22.4L4.915,22.4c-0.31-0.536,0.06-1.328,0.826-1.771l2.771-1.6c0.765-0.442,1.636-0.366,1.946,0.17 l0,0c0.309,0.536-0.061,1.328-0.826,1.77L6.86,22.57C6.095,23.012,5.224,22.936,4.915,22.4z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.6666666666666666s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M3.2,16L3.2,16c0-0.619,0.716-1.12,1.6-1.12H8c0.884,0,1.6,0.501,1.6,1.12l0,0c0,0.619-0.716,1.12-1.6,1.12 H4.8C3.917,17.12,3.2,16.619,3.2,16z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.75s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M4.915,9.6L4.915,9.6c0.309-0.536,1.18-0.612,1.945-0.17l2.771,1.6c0.765,0.441,1.135,1.234,0.826,1.77l0,0 c-0.31,0.536-1.181,0.612-1.946,0.17l-2.771-1.6C4.975,10.928,4.605,10.136,4.915,9.6z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.8333333333333334s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#887F7A",
    d: "M9.6,4.915L9.6,4.915c0.536-0.31,1.328,0.06,1.77,0.826l1.6,2.771c0.442,0.766,0.366,1.637-0.17,1.946l0,0 c-0.536,0.309-1.328-0.061-1.77-0.826L9.43,6.86C8.988,6.095,9.064,5.224,9.6,4.915z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.9166666666666666s",
    dur: "1s",
    to: 0,
    from: 1,
    attributeName: "opacity"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.66b1cdc2a8f6e9ab895500e9b8bebfb8.svg";
export { ForwardRef as ReactComponent };